import React from 'react';
import {DefaultFooter} from './Footers/FooterDefault';
import {FooterBX2023} from './Footers/FooterBX2023';
import {FooterBX2025} from './Footers/FooterBX2025';

export const Footer = () => {
  const client = window.appState.config.client;
  const aleTheme = window.appState.config.aleTheme;
  const hint = window.appState.config.realmConfig['cocosite.client.hint'];

  if (client === 'blanchard' && hint === 'bx2025') {
    return <FooterBX2025 />;
  }

  if (aleTheme === 'bx2023') {
    return <FooterBX2023 />;
  }

  return <DefaultFooter />;
};
